/**
 * План перехода между наборами открытых областей.
 * Общий префикс остаётся открытым; лишние области закрываются от вложенной к внешней,
 * недостающие открываются от внешней к вложенной.
 */
export function planScopeTransition(current: string[], target: string[]): { close: string[]; open: string[] } {
  let common = 0
  while (common < current.length && common < target.length && current[common] === target[common])
    common += 1

  return {
    close: current.slice(common).reverse(),
    open: target.slice(common),
  }
}
